import React, { Fragment } from 'react'
import { pathOr } from 'ramda'
import classnames from 'classnames'
import './FinalSteps.css'
import Ice from '../../../../assets/img/ice.png'
import CodeQR from '../../../../assets/img/code-qr.gif'
import Enjoy from '../../../../assets/img/enjoy.png'
import Info from '../../../../assets/img/info.png'

const FinalSteps = ({ mealDetail, isLoading }) => {
  const microwaveSteps = pathOr(
    null,
    ['cookingSteps', 'microwaveSteps'],
    mealDetail
  )
  const ovenSteps = pathOr(null, ['cookingSteps', 'ovenSteps'], mealDetail)

  if (!ovenSteps && !microwaveSteps) {
    return null
  }

  return (
    <div className={classnames('final-steps', { loading: isLoading })}>
      <h2 className={classnames('title-section', { loading: isLoading })}>
        Final step instructions.
      </h2>

      <div className="cooking cooking-row">
        {ovenSteps && (
          <div className={classnames('oven', { loading: isLoading })}>
            <h2>
              In the Oven
              {!isLoading && <span>recommended</span>}
            </h2>
            <div className={classnames('steps', { loading: isLoading })}>
              {ovenSteps.split('\n').map((step, i) => (
                <p key={i}>{step}</p>
              ))}
            </div>
            {/* .replace('\n', '<br/>') */}
            {!isLoading && (
              <h3>
                <img src={Enjoy} alt="enjoy" />
                <b>Enjoy it Warm!</b>
              </h3>
            )}
          </div>
        )}

        {microwaveSteps && (
          <div className={classnames('microwave', { loading: isLoading })}>
            <h2>In the Microwave</h2>
            <div className={classnames('steps', { loading: isLoading })}>
              {microwaveSteps.split('\n').map((step, i) => (
                <p key={i}>{step}</p>
              ))}
            </div>
            {!isLoading && (
              <h3>
                <img src={Enjoy} alt="enjoy" />
                <b>Enjoy it Warm!</b>
              </h3>
            )}
          </div>
        )}
      </div>

      {!isLoading && (
        <Fragment>
          <div className="cooking-row border-row">
            <div className="col-50">
              <div className="ice-img">
                <img src={Ice} alt="Brrrrr" />
              </div>
              <div>
                <p>
                  <span>Meals are delivered chilled</span> <br />
                  Containers are oven & microwave safe, lid is not safe.
                </p>
              </div>
            </div>
            <div className="col-50">
              <div className="ice-img">
                <img src={CodeQR} alt="Brrrrr" />
              </div>
              <div>
                <p>
                  <span>Scan the QR Code on your meal</span>
                  <br />
                  Find Heating instructions, Nutritional info, Expiration date{' '}
                </p>
              </div>
            </div>
          </div>
          <div className="note">
            <img src={Info} alt="info" />
            <span>
              Remove the plastic cup from inside the container before heating.
            </span>
          </div>
        </Fragment>
      )}
    </div>
  )
}

export default FinalSteps



// WEBPACK FOOTER //
// ./src/modules/MealDetail/components/FinalSteps/index.js